import {creates, hoistCmp} from '@xh/hoist/core';
import {EcoIndicatorWidgetModel} from './EcoIndicatorWidgetModel';
import {panel} from '@xh/hoist/desktop/cmp/panel';
import {chart} from '@xh/hoist/cmp/chart';
import {placeholder} from '@xh/hoist/cmp/layout';
import {Icon} from '@xh/hoist/icon';

export const ecoIndicatorWidget = hoistCmp.factory({
    model: creates(() => EcoIndicatorWidgetModel),
    render({model}) {
        return panel({
            items: model.indicator ? chart() : placeholder(Icon.gear(), 'Configure'),
            mask: 'onLoad'
        });
    }
});
